export var computeLongTermCare = function (age) {
    if (age < 19) {
        return 47.7;
    }
    if (age > 70) {
        return 206.57;
    }
    return [
        48.54,
        49.41,
        50.31,
        51.23,
        52.18,
        53.15,
        54.16,
        55.19,
        56.26,
        57.36,
        58.49,
        59.67,
        60.89,
        62.15,
        63.45,
        64.81,
        66.22,
        67.68,
        69.2,
        70.78,
        72.43,
        74.15,
        75.95,
        77.82,
        79.79,
        81.84,
        83.99,
        86.25,
        88.63,
        91.13,
        93.76,
        96.53,
        99.45,
        102.54,
        105.79,
        109.22,
        112.85,
        116.69,
        120.76,
        125.09,
        129.69,
        134.59,
        139.8,
        145.36,
        151.28,
        157.61,
        164.39,
        171.65,
        179.44,
        187.82,
        196.84,
        206.57,
    ][age - 19];
};
